/* eslint-disable @atlassian/relay/graphql-naming, @atlassian/relay/must-colocate-fragment-spreads */
import { graphql, readInlineData } from 'react-relay';

import { RovoAgentAri } from '@atlassian/ari';

import type { mapEdgeToAgent$key } from './__generated__/mapEdgeToAgent.graphql.ts';
import type { MentionAgent } from './types.ts';

export const mapEdgeToAgent = (ref: mapEdgeToAgent$key | null | undefined): MentionAgent | null => {
	if (!ref) {
		return null;
	}
	const node = readInlineData(
		graphql`
			fragment mapEdgeToAgent on AgentStudioAgent @inline {
				id
				name
				... on AgentStudioAssistant {
					description
					isFavourite
					isVerified
					creatorType
					identityAccount {
						id
						picture
					}
				}
			}
		`,
		ref,
	);

	if (typeof node.name !== 'string') {
		return null;
	}

	let agentId: string;
	try {
		agentId = RovoAgentAri.parse(node.id).agentId;
	} catch {
		return null;
	}

	return {
		id: agentId,
		name: node.name,
		description: node.description ?? '',
		avatarUrl: node.identityAccount?.picture ?? null,
		identityAccountId: node.identityAccount?.id ?? undefined,
		isFavourite: node.isFavourite ?? false,
		isVerified: node.isVerified ?? false,
		creatorType: node.creatorType ?? undefined,
	};
};
